import { isNumber } from 'lodash'
interface FormatDateProps {
  showYear?: boolean
  showTime?: boolean
  timeZone?: string
}

export function formatNumber(num: number): string {
  // TODO: reason to not use Intl.NumberFormat notation: compact for now
  // https://github.com/facebook/hermes/issues/1035
  if (num < 1e3) {
    return num.toString()
  }
  if (num < 1e6) {
    return `${Math.floor(num / 1e2) / 10}K`
  }
  if (num < 1e9) {
    return `${Math.floor(num / 1e5) / 10}M`
  }
  return `${Math.floor(num / 1e8) / 10}B`
}
export function formatDate(date: Date | string | undefined): string | undefined {
  if (!date) return undefined

  const dateObj = new Date(date)
  if (Number.isNaN(dateObj.getTime())) {
    return undefined
  }

  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

export const formatDateWithOptions = (date: Date, options: FormatDateProps) => {
  const { showYear, showTime } = options

  // Format the month
  const formatter = new Intl.DateTimeFormat('en', {
    month: 'short',
    ...(options.timeZone ? { timeZone: options.timeZone } : {})
  })
  const month = formatter.format(date)

  // Extract day, year, hours, and minutes
  const day = date.getDate()
  const year = date.getFullYear()
  const hours = date.getHours()
  const minutes = date.getMinutes()

  // Format minutes with leading zero if needed
  const formattedMinutes = minutes.toString().padStart(2, '0')

  // Construct the date string
  let formattedDate = `${month} ${day}${showYear ? `, ${year}` : ''}`

  if (showTime) {
    // Format hours to 12-hour format
    const hour12 = hours % 12 || 12
    const period = hours >= 12 ? 'PM' : 'AM'
    formattedDate += `, ${hour12}:${formattedMinutes} ${period}`
  }

  return formattedDate
}

export const formatToTimeZone = (date: Date, timeZone = 'America/Los_Angeles') => {
  const ptDate = new Intl.DateTimeFormat('en-US', {
    timeZone: timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false // 24-hour format
  }).format(date)

  return new Date(ptDate)
}

export function formatNumberUS(num: number | undefined): string {
  if (!isNumber(num)) {
    return '0'
  }
  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 })

  // Use the format method to format the number
  const formattedNumber = formatter.format(num)

  return formattedNumber
}

export function addDaysToDate(dateString: string, daysToAdd: number) {
  const date = new Date(dateString) // Convert the string to a Date object
  date.setDate(date.getDate() + daysToAdd) // Add the desired number of days
  return date
}
